/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData, FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped, FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSON, } from './FxIdApplicationStoreInAppEGSEgsInAppBillingData';
export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData(json)) {
        return FxIdApplicationStoreInAppEGSEgsInAppBillingDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreInAppEGSEgsInAppBillingData(value)) {
        return FxIdApplicationStoreInAppEGSEgsInAppBillingDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData.js.map